class Auth {
  constructor() {
    this.authenticated = false;
    // localStorage.setItem('auth', false)
  }

  login(cb) {
    this.authenticated = true;
    localStorage.setItem("auth", "true");
    setTimeout(() => {
      cb();
      window.location.reload();
    });
  }
  logout(cb) {
    this.authenticated = false;
    localStorage.user = "";
    localStorage.setItem("auth", "false");
    cb();
  }
  isAuthenticated() {
    var au = localStorage.getItem("auth");
    return au;
  }
}

export default new Auth();
